import { JsonObject } from '../models';

export enum ContentEventType {
  challenge_join = 'challenge_join',
  challenge_leave = 'challenge_leave',
  promo_completed = 'promo_completed',
  promo_dismissed = 'promo_dismissed',
}

export interface ContentEventCreatedResponse {
  contentId: string;
  eventId?: string;
  eventInfo?: JsonObject;
}
